import { ColumnConfigType } from 'shared/types';
import { IParticipantModel } from 'entities/competitions-b2b';

const fieldsBannerConfig: ColumnConfigType<IParticipantModel>[] = [
  {
    dataFieldName: 'id',
    name: 'ID',
    width: '10%',
  },
  {
    dataFieldName: 'title',
    name: 'Заголовок',
    width: '15%',
  },
  {
    dataFieldName: 'place',
    name: 'Место',
    width: '15%',
  },
  {
    dataFieldName: 'created_at',
    name: 'Дата создания',
    width: '20%',
  },
  {
    dataFieldName: 'purchase_amount_total',
    name: 'Сумма продаж',
    width: '35%',
  },
];

export { fieldsBannerConfig };
